import {createReducer} from '@reduxjs/toolkit'
import {GetWidgetDataResponse} from '@wix/ambassador-events-ui-v1-widget-data/types'

export interface MembershipOffersState {
  membershipOffers: GetWidgetDataResponse['membershipOffers']
}

const defaultState: MembershipOffersState = {
  membershipOffers: {},
}

export const membershipOffers = createReducer(defaultState, _builder => {})
